module.exports = __webpack_public_path__ + "static/media/20.22c37d23.jpg";